var browserDeploy = function browserDeploy() {
  throw new Error('Deploys not supported in the browser');
};

module.exports = browserDeploy;